import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isPositiveNumber } from "et3-type-guards";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3InputField from "../../core/et3-input/et3-text-input/InputField";
import getCoreSideMenuStore from "../../stores/core/core-side-menu";
import {
  SIDE_BAR_CONTENT_WIDTH,
  SIDE_BAR_SEARCH_BACKGROUND,
  SIDE_BAR_SEARCH_BORDER,
  SIDE_BAR_SEARCH_BORDER_FOCUS,
  SIDE_BAR_SEARCH_FIELD_WIDTH,
  SIDE_BAR_SEARCH_FONT_SIZE,
  SIDE_BAR_SEARCH_GAP,
  SIDE_BAR_SEARCH_HEIGHT,
  SIDE_BAR_SEARCH_ICON_SIZE,
  SIDE_BAR_SEARCH_PADDING_X,
  SIDE_BAR_SEARCH_RADIUS,
  SIDE_BAR_TRANSITION
} from "./side-bar-constants";

const SideBarSearch = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY, getFontSize, getFontType } = theme;
  const navigate = useNavigate();
  const [isFocused, setIsFocused] = useState(false);
  const searchValue = getCoreSideMenuStore().sideBarSearchText.get();

  const runSearch = () => {
    const userID = getCoreSideMenuStore().sideBarSearchText.get();
    navigate({
      pathname: "/users/advanced",
      search: `?id=${userID}`
    });
    getCoreSideMenuStore().handleSearch();
  };

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={SIDE_BAR_CONTENT_WIDTH}
      height={SIDE_BAR_SEARCH_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={SIDE_BAR_SEARCH_BACKGROUND}
      style={{
        boxSizing: "border-box",
        borderRadius: SIDE_BAR_SEARCH_RADIUS * unitX,
        border: isFocused
          ? SIDE_BAR_SEARCH_BORDER_FOCUS
          : SIDE_BAR_SEARCH_BORDER,
        paddingLeft: SIDE_BAR_SEARCH_PADDING_X * unitX,
        paddingRight: SIDE_BAR_SEARCH_PADDING_X * unitX,
        gap: SIDE_BAR_SEARCH_GAP * unitX,
        transition: SIDE_BAR_TRANSITION
      }}
      onClick={() => {}}
    >
      <FontAwesomeIcon
        className="clickable"
        icon={faSearch}
        color={isFocused ? colors.all.white : colors.all.borderBlue}
        style={{
          width: SIDE_BAR_SEARCH_ICON_SIZE * unitX,
          height: SIDE_BAR_SEARCH_ICON_SIZE * unitY,
          flexShrink: 0,
          transition: SIDE_BAR_TRANSITION
        }}
        onClick={() => runSearch()}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={SIDE_BAR_SEARCH_FIELD_WIDTH}
        height={0}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          width: "100%",
          minWidth: 0
        }}
        onClick={() => setIsFocused(true)}
      >
        <Et3InputField
          type={"number"}
          fieldClassName="input"
          label={i18n.get("SEARCH_USER_ID")}
          value={isPositiveNumber(searchValue) ? searchValue : ""}
          onChoose={(value: number) => {
            getCoreSideMenuStore().sideBarSearchText.set(value);
          }}
          onBlur={() => setIsFocused(false)}
          onEnter={() => runSearch()}
          style={{
            boxSizing: "border-box",
            border: 0,
            padding: 0,
            backgroundColor: colors.all.transparent,
            color: colors.all.white,
            fontFamily: getFontType("MEDIUM"),
            fontSize: getFontSize(SIDE_BAR_SEARCH_FONT_SIZE),
            width: "100%",
            minWidth: 0
          }}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default SideBarSearch;
